import React from 'react';

export default function PartnerJepang() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Partner Jepang</h1>
      <p className="text-gray-500">Halaman Partner Jepang</p>
    </div>
  );
}
